module.exports = __webpack_public_path__ + "static/media/group-admin.b44a5b61.jpeg";